import Enumerable from "linq";
import { ArrayComplexTranslator } from "../../values";

export class ItemsTranslator {
  from<TBean, TItem>(source: TBean | TBean[], from: (s: TBean) => TItem): TItem[] {
    return source
      ? Enumerable.from(this.arrayComplex.from(source)).select(s => from(s)).toArray()
      : [];
  }

  to<TBean, TItem>(source: TItem[], to: (s: TItem) => TBean): TBean | TBean[] {
    return this.arrayComplex.to(Enumerable.from(source ? source : []).select(s => to(s)).toArray());
  }

  private readonly arrayComplex = new ArrayComplexTranslator();
}
